import React from "react";
import { CoachClientsFormScreen } from "../../../../components/coach-client-forms/CoachClientsFormScreen";

export function CoachClientsFormRoute() {
  return <CoachClientsFormScreen />;
}
